<template>
    <percent-input
        v-model="inputValue" suffix
        class="border focus:ring-indigo-400 focus:border-indigo-400 border-gray-300 rounded-md block w-full sm:text-sm sm:leading-5 dark:bg-gray-700 dark:border-gray-800 dark:text-gray-300"
        :class="{ 'border-red-500 dark:border-red-500': form && form.errors.hasOwnProperty(name), 'px-3 py-2': !noPadding }"/>
</template>

<script>
import { PercentInput } from 'vue-percent-input';

export default {
    components: { PercentInput },

    props: {
        value: {
            required: true,
        },
        form: Object,
        noPadding: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        inputValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>
